import ApiBase from 'Services/Api/ApiBase';

class NotificationSettings extends ApiBase {
    route = '/admin/comms/notification-settings';
}

export default new NotificationSettings();
